import Vue from "vue";
import { mapGetters } from "vuex";

import { LoadingSpinner, PartDetailsLink } from "@/components";
import {default as SupersessionIcon} from "./SupersessionIcon.vue";

import { formatDateTime, stringHelper } from "@/components/mixins";
import { ErrorLogService, PartDetailServices } from "@/services";

export default Vue.extend({
    name: "SupersessionTab",

    components: {
        LoadingSpinner,
        PartDetailsLink,
        SupersessionIcon
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["user", "getContentItem", "activeAccountId"]),
        longestChainLength(){
            var longestChainLength = 0;
            this.supersessionChains.forEach(function(chain: any){
                if(chain.length > longestChainLength){
                    longestChainLength = chain.length ;
                }
            });
            return longestChainLength;
        },
        showReplacementItems() {
            return this.replacementItems?.length > 0;
        },
        showChoiceItems() {
            return this.choiceItems?.length > 0;
        },
    },

    props: {
        partId: {
            type: Number,
            default: 0,
        },
        oemPartCode: {
            type: String,
            default: "",
        },
    },

    data: () => ({
        replacingItemColumns: [
            { key: "ReplacementOemPartCode", label: "Part Number" },
            { key: "PartDescription", localizationKey: "Description" },
            { key: "ReplacementPartQuantity", localizationKey: "ReplacingQuantity" },
            { key: "ServiceabilityIndicator", label :"Serviceability"}
        ],
        loadingSupersessionChains: false,
        loadingReplacementItems: false,
        haveSuccessfullyLoadedSupersessionChains: false,
        haveSuccessfullyLoadedReplacementItems: false,
        supersessionChains: {},
        replacementItems: {},
        choiceItems: {}
    }),

    methods: {
        async getSupersessionChains() {
            try {
                this.loadingSupersessionChains = true;

                const params = {
                    partId: this.partId,
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                };

                const data = await PartDetailServices.getSupersession(params);

                this.supersessionChains= data;
                this.haveSuccessfullyLoadedSupersessionChains = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
               this.loadingSupersessionChains = false;
            }
        },
        async getReplacementItems() {
            try {
                this.loadingReplacementItems = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partId: this.partId,
                    oemPartCode: this.oemPartCode
                };

                await PartDetailServices.getReplacementItems(params)
                    .then(results => {
                        if (results) {
                            this.filterReplacementItems(results);
                        }
                    });

                this.haveSuccessfullyLoadedReplacementItems = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
               this.loadingReplacementItems = false;
            }
        },
        filterReplacementItems(items: any) {
            // 'CA' is the only choice supersession type, stands for one-to-many Choice
            // all others are replacing type
            this.replacementItems = items.filter(item => {
                return item.SupersessionType !== "CA";
            });

            this.choiceItems = items.filter(item => {
                return item.SupersessionType === "CA";
            });
        },
        partsInChain(chain: any) {
            var partsInChain: any = [];
            
            chain.forEach(function(edge: any){
                var fromPart = {
                    OemPartCode: edge.FromOemPartCode,
                    SupersessionType: edge.SupersessionType
                }

                partsInChain.push(fromPart);
                if(edge.SupersessionLevel == -1){

                    var toPart = {
                        OemPartCode: edge.ToOemPartCode,
                        SupersessionType: edge.SupersessionType
                    }
                    partsInChain.push(toPart);
                }
            });
        
            return partsInChain;
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedReplacementItems && !this.loadingReplacementItems){
                this.getReplacementItems();
            }
            if(!this.haveSuccessfullyLoadedSupersessionChains && !this.loadingSupersessionChains){
                this.getSupersessionChains();
            }
        }
    },
});
